import InstallerInformationView from './InstallerInformationView';
export default InstallerInformationView;
